var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.052 13.602a1.068 1.068 0 0 0-.57-.57.596.596 0 0 0-.222-.05.986.986 0 0 0-.16-.036l-20.864-.248a1.05 1.05 0 1 0-.012 2.092l18.314.198-26.692 26.691a1.05 1.05 0 1 0 1.485 1.485l26.692-26.692.198 18.315a1.048 1.048 0 0 0 1.051 1.051c.274-.009.534-.119.73-.309a1.013 1.013 0 0 0 .31-.755l-.21-20.826-.05-.173a.402.402 0 0 0 0-.173Z",
    fill: "currentColor"
  })));
};

export default SvgArrowRight;